// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"40410428","366":"29895be5","974":"1d0ca136"}[chunkId] + ".chunk.css";
};